import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
// import { IS_SP } from '../const/config';
gsap.registerPlugin(ScrollToPlugin);

/**
 * アンカー処理をするクラス
 */
class Anchor {
  constructor(el) {
    this.DOM = {};
    this.DOM.el = el;
    this.DOM.menuButton = document.querySelector('[data-menu-button]');
    this.DOM.menuContent = document.querySelector('[data-menu-content]');
    if (!this.DOM.el) return;

    this.init();
  }
  init() {
    this.onClick = (e) => this._onClick(e);
    this.DOM.el.addEventListener('click', this.onClick);
  }
  _closeMenu = () => {
    if( this.DOM.menuButton ){
      this.DOM.menuButton.classList.remove('is-opened');
    }
    if( this.DOM.menuContent ){
      this.DOM.menuContent.classList.remove('is-opened');
    }
  }
  _onClick(e) {
    e.preventDefault();

    // const $header = document.querySelector('.js-header');
    // const offset = IS_SP ? $header.clientHeight : $header.clientHeight;
    const targetId = this.DOM.el.getAttribute('href').replace(/^\/(#.*)/, '$1');
    const $section = document.querySelector(targetId);
    const rect = $section.getBoundingClientRect();
    const y = rect.top + window.scrollY;
    // const y = rect.top + window.scrollY - offset;

    // メニューが開いていたら閉じる
    this._closeMenu();

    // スクロールする

    if (!this.DOM.el.classList.contains('js-no-scroll')) {
      gsap.to(window, {
        duration: 0.4,
        scrollTo: {
          y
        }
      });
    } else {
      gsap.to(window, {
        duration: 0,
        scrollTo: {
          y
        }
      });
    }
  }
}

/**
 * アンカーインスタンスの生成
 */
export class Anchors {
  constructor() {
    this.DOM = {};
    this.DOM.links = document.querySelectorAll('a');
    this.anchors = [];

    this.init();
  }
  init() {
    for (const link of this.DOM.links) {
      if (/^#.*/.test(link.getAttribute('href'))) {
        this.anchors.push(new Anchor(link));
      }
    }
  }
  destroy() {
    for (const anchor of this.anchors) {
      anchor.dispose();
    }
  }
}
